import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-start gap-10">
        {/* Left Side: Logo and Address */}
        <div className="flex flex-col space-y-8">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/2fbbf08e099a9ef9870e1c5f3effee5d6d36993ea30e1b10ed25bd1173bb5e1eabb168f88e9bc68e478ef3a4b0682ce3/images/aW1hZ2UvcG5n/061b124a453d246acf528d3d89a4cc45.png" 
            alt="GeoSpaceWeb Logo" 
            className="h-10 w-auto object-contain self-start" 
          />
          <div className="text-slate-600 text-[15px] space-y-1.5">
            <p>Made with ❤️ by Geospaceweb</p>
            <p>13359 N Hwy 183 Suite 406-662, Austin, TX 78750</p>
          </div>
        </div>

        {/* Right Side: Links */}
        <div className="flex flex-col space-y-5 md:text-right pt-2">
          <a 
            href="https://geospaceweb.com/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-slate-600 hover:text-brand-600 transition-colors text-[15px]"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;